import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Zello from './Zello';
import { BrowserRouter as Router } from "react-router-dom";
import { unregister } from './registerServiceWorker';
import axios from 'axios'
import 'semantic-ui-css/semantic.min.css';

const renderApp = function() {
  ReactDOM.render(
    <Router>
      <App/>
    </Router>,
    document.getElementById('root')
  );
};

axios.request({
  url: Zello.getApiUrl('/users/me'),
  method: 'get',
  headers: {'Accept': 'application/json'},
  withCredentials: true
}).then((response) => {
  if (response.data) {
    Zello.setProfile(response.data);
  }
}).catch((e) => {
  console.log("Error on auth callback, starting up");
}).then(() => {
  console.log("Completed auth callback, starting up");
  renderApp();
});

// To enable service worker: registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js